import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark text-white py-5">
      <div className="container">
        <div className="row g-4">
          <div className="col-lg-4">
            <h5 className="fw-bold mb-3">Polzenrom Ltd</h5>
            <p className="text-muted">
              Professional delivery of modern digital solutions tailored to your business needs.
            </p>
          </div>
          <div className="col-lg-4">
            <h6 className="fw-bold mb-3">Services</h6>
            <ul className="list-unstyled">
              <li className="mb-2">
                <i className="fas fa-check text-primary me-2"></i>IT and Tech Solutions
              </li>
            </ul>
          </div>
          <div className="col-lg-4">
            <h6 className="fw-bold mb-3">Contact Us</h6>
            <ul className="list-unstyled">
              <li className="mb-2">
                <i className="fas fa-building text-primary me-2"></i>
                <strong>POLZENROM LTD</strong>
              </li>
              <li className="mb-2">
                <i className="fas fa-map-marker-alt text-primary me-2"></i>
                Sfairou 1, 3118, Limassol, Cyprus
              </li>
              <li className="mb-2">
                <i className="fas fa-envelope text-primary me-2"></i>
                info@polzenrom.com
              </li>
            </ul>
          </div>
        </div>
        <hr className="my-4" />
        <div className="row align-items-center">
          <div className="col-md-6">
            <p className="mb-0">&copy; {currentYear} Polzenrom Ltd. All Rights Reserved.</p>
          </div>
          <div className="col-md-6 text-md-end">
            <p className="mb-0">Registration No: ΗΕ 478398 | Limassol, Cyprus</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

